import {lazyComponent} from 'coreUtils/adapters/lazy';

const LanguageSelectorFlyout = lazyComponent(() => import('./LanguageSelectorFlyout'));

export {LanguageSelectorFlyout as default};
